import { Component, Input } from '@angular/core';
import { TreesCuttingInfoForm } from '../../forms/trees-cutting-info-form';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';
import {
  ValidationErrorsComponent
} from '../../../../../../../../common/validation-errors/validation-errors.component';

@Component({
  selector: 'app-property-owner-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    NgxMaskDirective,
    ValidationErrorsComponent
  ],
  templateUrl: './property-owner-form.component.html',
})
export class PropertyOwnerFormComponent {

  @Input()
  public form: TreesCuttingInfoForm | undefined;

  constructor() {
  }

}
